export default __webpack_public_path__ + "static/media/granville23.ba051d9c.jpg";